import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid} from '@mui/material'

import ChoiceButton from '@progyny/components/Buttons/ChoiceButton'
import MobileStickyActions, {
  MOBILE_STICKY_HEIGHT,
} from '@progyny/components/MobileStickyActions'
import {GenderIdentities, GenderIdentityType, UNSET} from '@progyny/const/index'
import {useResponsive} from '@progyny/hooks/useResponsive'
import {SetupProfileSubProps} from '@progyny/pages/SetUpProfile/types'

const GenderIdentity: React.FC<SetupProfileSubProps> = (props) => {
  const {
    onboardingData,
    navigator: Navigator,
    goBack,
    persistMemberData,
    callback,
  } = props
  const {t} = useTranslation()
  const isMobile = useResponsive('down', 'md')
  const handleChoiceClick = async (choice: string) => {
    await persistMemberData({genderIdentity: choice}, callback)
  }

  function filterItems(items: GenderIdentityType[]) {
    return items.filter(
      (item) =>
        item.possibleCombo?.find(
          (combo: string) => combo === onboardingData.birthAssignedSex
        ) && item.value !== UNSET
    )
  }

  return (
    <>
      <Grid
        container
        justifyContent={'center'}
        sx={{pb: {xs: MOBILE_STICKY_HEIGHT, md: 0}}}
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          width='100%'
        >
          {filterItems(GenderIdentities).map((item: any) => (
            <ChoiceButton
              data-role={'gender-identity-submit-button'}
              isSelected={onboardingData.genderIdentity === item.value}
              key={item.value}
              onClick={() => handleChoiceClick(item.value)}
              size={'large'}
            >
              {t(item.label)}
            </ChoiceButton>
          ))}
        </Box>
      </Grid>
      <MobileStickyActions>
        <Navigator
          skipDataRole={'gender-identity'}
          onPrevButtonClick={goBack}
          backButtonType='outlined'
          singleCentered
          fullWidth={isMobile}
        />
      </MobileStickyActions>
    </>
  )
}

export default GenderIdentity
